<!-- Sidenav -->
<div class="" (window:resize)="isMobile($event)">
  <app-navbar [ngClass]="{ 'sidenav fixed-left': isMobileResolution === false }"></app-navbar>
  <div class="main-content">
    <router-outlet *ngIf="inProgress === 'none'"></router-outlet>
  </div>
</div>
